import { useFormik } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  fullName: yup.string().required('Vui lòng nhập tên'),
  email: yup
    .string()
    .required('Vui lòng nhập email')
    .email('Vui lòng nhập đúng định dạng email')
    .trim()
    .test(
      'valid_email',
      'Vui lòng nhập đúng định dạng email',
      function (value) {
        const regex = /^[a-z0-9]+([-._][a-z0-9]+)*@([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{1,10}$/;
        return regex.test(value);
      }
    ),
  description: yup.string().required('Vui lòng nhập nội dung'),
});

const initialValues = {
  fullName: '',
  email: '',
  description: '',
};

const useSupportForm = ({ handleSubmit }) => {
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return {
    formik,
  };
};

export default useSupportForm;
